import React, { useState } from 'react';
import { Alert, AlertIcon, Box, Button, Link } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import Plugin, { PluginProps } from '../Plugin';

const getDataTypeProps = (dataType: string) => {
  const dataTypeProps: Record<string, any> = {
    none: {
      status: 'success',
      color: 'gray',
    },
    todo: {
      status: 'success',
      color: 'green',
    },
    error: {
      status: 'error',
      color: 'red',
    },
    danger: {
      status: 'error',
      color: 'red',
    },
    warning: {
      status: 'warning',
      color: 'orange',
    },
    info: {
      status: 'info',
      color: 'blue',
    },
  };
  return dataTypeProps[dataType];
};

const HighlightSection = (props: PluginProps) => {
  const { content, studyGroup } = props;
  const { programId } = useParams<{ programId?: string }>();

  const color = content.data.background_color;

  const [dataTypeProps, setDataTypeProps] = useState(
    getDataTypeProps(content.data.type),
  );

  const changeDataTypeProps = (dataType: string) => {
    setDataTypeProps(getDataTypeProps(dataType));
  };

  return (
    <Box
      borderWidth={2}
      borderColor={color ? color : dataTypeProps.color}
      borderRadius={4}
      overflow="hidden"
    >
      <Alert
        status={dataTypeProps.status}
        backgroundColor={color}
        variant="solid"
      >
        <AlertIcon />
        {content.data.title}
      </Alert>

      <Box p={4}>
        {content.children.map((child, index) => {
          return (
            <Plugin
              key={index}
              {...props}
              content={child}
              changeHighlightSectionType={changeDataTypeProps}
            />
          );
        })}
        {(content.data.editor_link || content.data.is_text_editor_link) && (
          <div style={{ width: '100%', textAlign: 'center' }}>
            {content.data.is_text_editor_link ? (
              <Button
                size="lg"
                colorScheme="blue"
                onClick={() => {
                  const params = new URLSearchParams();
                  if (studyGroup?.pk) params.set('studyGroupId', studyGroup.pk);
                  if (programId) params.set('programId', programId);
                  if (content.data.editor_default_text) params.set('defaultText', content.data.editor_default_text);
                  window.open('/script-writer/?' + params.toString(), '_blank');
                }}
              >
                {content.data.editor_link_label}
              </Button>
            ) : (
              <Link href={content.data.editor_link} target="_blank">
                <Button size="lg" colorScheme="blue">
                  {content.data.editor_link_label}
                </Button>
              </Link>
            )}
          </div>
        )}
      </Box>
    </Box>
  );
};

export default HighlightSection;
